import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ActionButton from "components/common/ActionButton";

import { Button, Form, Row, Spinner, Table } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchSocialPlatforms } from "../../../../hooks/useFetchSocialPlatforms";
import { useMemo } from "react";

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: "10px",
          // paddingTop: "15px",
        }}
      >
        ☰
      </td>
      {children}
    </tr>
  );
};

const SocialPlatforms = () => {
  const {
    register,
    getValues,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    fields: productSocialLinks,
    append: appendProductSocialLinks,
    remove: removeProductSocialLinks,
    move,
  } = useFieldArray({
    control,
    name: "productSocialLinks",
  });

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = productSocialLinks.findIndex(
        (item) => item.id === active.id,
      );
      const newIndex = productSocialLinks.findIndex(
        (item) => item.id === over.id,
      );
      move(oldIndex, newIndex);
    }
  };

  const { data, isLoading } = useFetchSocialPlatforms();
  const productSocialLinksValues = watch("productSocialLinks") || [];

  const platforms = data?.data?.data || [];

  const platformById = useMemo(() => {
    return platforms.reduce((acc, p) => {
      acc[p.id] = p;
      return acc;
    }, {});
  }, [platforms]);

  const SOCIAL_URL_PREFIX = {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    twitter: "https://twitter.com/",
    linkedin: "https://linkedin.com/in/",
    youtube: "https://youtube.com/",
    tiktok: "https://tiktok.com/@",
  };

  if (isLoading) {
    return <Spinner variant="primary" animation="border" />;
  }

  return (
    <>
      {/* <Card.Header as="h6" className="bg-body-tertiary mb-2">
        Shipping And Warranty
      </Card.Header> */}

      {isLoading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Row className="gx-2 ">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={productSocialLinks.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table responsive>
                <thead className="bg-200">
                  <tr>
                    <th
                      scope="col"
                      className="w-0 fs-10 text-center"
                      style={{ width: "10px" }}
                    >
                      Order
                    </th>

                    <th
                      scope="col"
                      className="fs-10"
                      style={{ width: "250px" }}
                    >
                      Social Platform
                    </th>
                    <th scope="col" className="fs-10">
                      URL
                    </th>

                    <th
                      style={{ width: "10px" }}
                      scope="col"
                      className="fs-10 text-center"
                    >
                      Status
                    </th>

                    <th
                      scope="col"
                      style={{ padding: "9px", width: "10px" }}
                      className=" text-end"
                    >
                      <ActionButton
                        icon="plus"
                        variant="success"
                        title="Add"
                        className="px-1 py-0"
                        onClick={() => appendProductSocialLinks({})}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {productSocialLinks.map((item, index) => (
                    <SortableItem key={item.id} id={item.id}>
                      {/* <td style={{ padding: "5px" }}>
                        <Form.Group controlId="formGroupName">
                          <Form.Select
                            aria-label="socialPlatformId"
                            isInvalid={
                              !!errors.productSocialLinks?.[index]
                                ?.socialPlatformId
                            }
                            {...register(
                              `productSocialLinks[${index}].socialPlatformId`
                            )}
                          >
                            <option value="">Select</option>
                            {data?.data?.data?.map((d) => (
                              <option value={d.id}>{d.name}</option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.productSocialLinks?.[index]?.socialPlatformId
                                ?.message
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td> */}
                      <td style={{ padding: "5px" }}>
                        <Form.Group controlId="formGroupName">
                          {/* <Form.Select
                            aria-label="socialPlatformId"
                            isInvalid={
                              !!errors.productSocialLinks?.[index]
                                ?.socialPlatformId
                            }
                            {...register(
                              `productSocialLinks[${index}].socialPlatformId`
                            )}
                          >
                            <option value="">Select</option>
                            {data?.data?.data
                              ?.filter((d) => {
                                const selectedIds = productSocialLinksValues
                                  .map((p) => p.socialPlatformId)
                                  .filter(Boolean); // remove undefined or empty
                                const currentValue = productSocialLinksValues[index]?.socialPlatformId;

                                // Keep current value, exclude others
                                return !selectedIds.includes(d.id.toString()) || d.id.toString() === currentValue;
                              })
                              .map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name}
                                </option>
                              ))}
                          </Form.Select> */}
                          <Form.Select
                            aria-label="socialPlatformId"
                            isInvalid={
                              !!errors.productSocialLinks?.[index]
                                ?.socialPlatformId
                            }
                            {...register(
                              `productSocialLinks.${index}.socialPlatformId`,
                              {
                                onChange: (e) => {
                                  const platformId = e.target.value;

                                  // Clear URL if empty
                                  if (!platformId) {
                                    setValue(
                                      `productSocialLinks.${index}.url`,
                                      "",
                                    );
                                    return;
                                  }

                                  // Lookup platform by ID
                                  const platform = platformById[platformId];
                                  if (!platform) return;

                                  const prefix =
                                    SOCIAL_URL_PREFIX[
                                      platform.name.toLowerCase()
                                    ];

                                  if (prefix) {
                                    setValue(
                                      `productSocialLinks.${index}.url`,
                                      prefix,
                                      { shouldValidate: true },
                                    );
                                  }
                                },
                              },
                            )}
                          >
                            <option value="">Select</option>

                            {data?.data?.data
                              ?.filter((d) => {
                                const selectedIds = productSocialLinksValues
                                  .map((p) => p.socialPlatformId)
                                  .filter(Boolean); // remove undefined or empty
                                const currentValue =
                                  productSocialLinksValues[index]
                                    ?.socialPlatformId;

                                // Keep current value, exclude others
                                return (
                                  !selectedIds.includes(d.id.toString()) ||
                                  d.id.toString() === currentValue
                                );
                              })
                              .filter((d) => d.status)
                              .map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name}
                                </option>
                              ))}
                          </Form.Select>

                          <Form.Control.Feedback type="invalid">
                            {
                              errors.productSocialLinks?.[index]
                                ?.socialPlatformId?.message
                            }
                          </Form.Control.Feedback>

                          <Form.Control.Feedback type="invalid">
                            {
                              errors.productSocialLinks?.[index]
                                ?.socialPlatformId?.message
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "5px" }}>
                        <Form.Group controlId="formGroupName">
                          <Form.Control
                            type="text"
                            id="url"
                            isInvalid={
                              !!errors.productSocialLinks?.[index]?.url
                            }
                            {...register(`productSocialLinks[${index}].url`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.productSocialLinks?.[index]?.url?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "5px" }} className="text-center">
                        <Form.Check
                          type="checkbox"
                          id="defaultSwitch"
                          className="mt-1"
                          defaultChecked={!state}
                          isInvalid={
                            !!errors.productSocialLinks?.[index]?.status
                          }
                          {...register(`productSocialLinks[${index}].status`)}
                        />
                      </td>
                      <td
                        style={{ padding: "5px", maxWidth: "10px" }}
                        className="text-center"
                      >
                        <ActionButton
                          icon="trash-alt"
                          title="Delete"
                          variant="danger"
                          className="px-1 py-0"
                          onClick={() => removeProductSocialLinks(index)}
                        />
                      </td>
                    </SortableItem>
                  ))}
                </tbody>
              </Table>
            </SortableContext>
          </DndContext>
        </Row>
      )}
    </>
  );
};

export default SocialPlatforms;
